import queryString from 'query-string';

const PinterestTarget = (shareTarget, media, description) => {
    const baseUri = "https://www.pinterest.com/pin/create/button/?";

    const query = {
        url: shareTarget || "https://www.schnoffle.de/",
        media: media || "https://www.schnoffle.de/media/schnoffle.29e34cbe.jpg",
        description: description,
    };

    return baseUri + queryString.stringify(query);
}

export default PinterestTarget;



// WEBPACK FOOTER //
// ./src/components/sharing/PinterestLinkGenerator.js